export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_06_end.40a88cd8.jpg";